import type { Huollettava } from 'todistukset-common/src/vtj/vtj-kysely/huoltod-soap-response-converter'
import { TodistuksetUser } from 'todistukset-common/src/vtj/types/user'

export const hasDependants = (user: TodistuksetUser): boolean =>
  Array.isArray(user.huollettavat) && user.huollettavat.length > 0

export const isDependantRestricted = (dependant: Huollettava): boolean =>
  dependant.isSafetyProhibited ||
  dependant.isHuoltajaSafetyProhibited ||
  dependant.isHuostaanotto ||
  false
